/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { useEffect, useState, useCallback } from 'react';
import { toastr } from 'react-redux-toastr';
import Loading from 'xpi-black-ui/Base/Loading';
import Page from 'xpi-black-ui/Base/Page';
import { Row } from 'xpi-black-ui/Base/Grid';
import { H1, Text } from 'xpi-black-ui/Base/Typography';
import Dropdown from 'xpi-black-ui/Common/Dropdown';

import useAntecipation from 'store/Antecipation/queries/useAntecipation';
import useAntecipationStore from 'store/Antecipation/state';

import BlackContainer from 'components/Common/BlackContainer';
import UnwindingFilter from '../../components/Filters/UnwindingFilter';
import GenericTableBox from '../../components/Generics/GenericTableBox';
import UnwindingTable from '../../components/Tables/UnwindingTable';
import UnwindingDetailsDialog from '../../components/Dialogs/UnwindingDetailsDialog';
import UnwindingDialog from '../../components/Dialogs/UnwindingDialog';
import WrapperTable, { Link } from './styles';

import { useNotificationContext } from '../../../state/notification';

const DEFAULT_FILTERED_OPTIONS_STATE = {
  AdvisorCodes: [],
  Clients: [],
  Tickers: [],
  Structures: [],
  OperationTimeByMonth: { min: 0, max: 0 },
  CurrentProfitPercentage: { min: 0, max: 0 },
  CurrentProfitOnMaxContractedPercentage: { min: 0, max: 0 },
  OperationIds: [],
};

const UnwindingPage = () => {
  const [state] = useNotificationContext();
  const { current } = state;
  const { data } = current;

  const [isLoading, setIsLoading] = useState(false);
  const [antecipateIsLoading, setAntecipateIsLoading] = useState(false);
  const [isOpenTableDetailsDialog, setIsOpenTableDetailsDialog] = useState(false);
  const [isOpenTableUnwindingDialog, setIsOpenTableUnwindingDialog] = useState(false);
  const [positionSelected, setPositionSelected] = useState(undefined);
  const [orderBy, setOrderBy] = useState({ Column: 'CurrentPosition.Profit.Percentage', Direction: 'OrderByDescending' });
  const [pagination, setPagination] = useState({ currentPage: 1, totalPages: 0 });
  const [filteredOptions, setFilteredOptions] = useState(DEFAULT_FILTERED_OPTIONS_STATE);

  const { outdatedPositions, anticipate, getReport } = useAntecipationStore();

  const {
    positions,
    filters,
    totalPages: newTotalPages,
    currentPage: newCurrentPage,
    isLoading: filterIsLoading,
    isSuccess,
    refetchAntecipation,
    status: filterStatus,
  } = useAntecipation(pagination.currentPage, filteredOptions, orderBy, data);

  useEffect(() => {
    if (isSuccess) {
      setFilteredOptions(oldState => ({ ...oldState, ...{ OperationIds: data.operations } }));
    }
  }, [data]);

  useEffect(() => {
    if (newTotalPages < pagination.currentPage) {
      setPagination(oldState => ({ ...oldState, currentPage: 1 }));
    }
  }, [positions]);

  const onPageChange = useCallback(({ currentPage }) => {
    setPagination(oldState => ({ ...oldState, currentPage }));
  }, [orderBy, filteredOptions]);

  const onOpenTableDialog = useCallback((position, isDetailsDialog) => {
    setPositionSelected(position);
    setIsOpenTableDetailsDialog(isDetailsDialog);
    setIsOpenTableUnwindingDialog(!isDetailsDialog);
  }, []);

  const onCloseTableDialog = useCallback(() => {
    setPositionSelected(undefined);
    setIsOpenTableDetailsDialog(false);
    setIsOpenTableUnwindingDialog(false);
    setAntecipateIsLoading(false);
  }, []);

  const onAcceptTerm = useCallback(async ({ operationId, quantity, comissionFeePercentage, sellAsset }) => {
    setAntecipateIsLoading(true);
    try {
      await anticipate({
        operationId,
        quantity,
        comissionFeePercentage,
        sellAsset,
      }).then(() => {
        toastr.success('Sucesso...', 'Posição enviada para antecipação!');
        refetchAntecipation();
        onCloseTableDialog();
        setAntecipateIsLoading(false);
      });
    } catch (error) {
      const errorMessage = error.response.data?.errorMessages?.length > 0
        ? error.response.data?.errorMessages[0]
        : 'Não foi possível antecipar esta Posição.';

      toastr.error('Ops...', errorMessage);
      setAntecipateIsLoading(false);
    } finally {
      setIsLoading(false);
      setAntecipateIsLoading(false);
    }
  }, [positions]);

  const downloadReport = (response) => {
    const file = new Blob([response], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const a = document.createElement('a');
    document.body.appendChild(a);
    const url = window.URL.createObjectURL(file);
    a.href = url;
    a.download = 'PosicoesDisponiveisAntecipacao';
    a.click();
  };

  const onGetReport = useCallback((Filters) => {
    setIsLoading(true);

    const NEW_FILTERS = Filters ? { ...Filters } : undefined;
    if (NEW_FILTERS) {
      if (Filters.OperationTimeByMonth.min === 0 && Filters.OperationTimeByMonth.max === 0) delete NEW_FILTERS.OperationTimeByMonth;
      if (Filters.CurrentProfitPercentage.min === 0 && Filters.CurrentProfitPercentage.max === 0) delete NEW_FILTERS.CurrentProfitPercentage;
      if (Filters.CurrentProfitOnMaxContractedPercentage.min === 0 && Filters.CurrentProfitOnMaxContractedPercentage.max === 0) delete NEW_FILTERS.CurrentProfitOnMaxContractedPercentage;
    }

    getReport({
      Filters: NEW_FILTERS,
    }).then((response) => {
      const { data: reportData, status } = response;
      if (status === 200) {
        if (reportData.byteLength > 0) {
          downloadReport(reportData);
        } else {
          toastr.info('Nenhum registro encontrado', 'Ops...');
        }
      } else {
        toastr.error('Erro ao carregar o relatório', 'Ops...');
      }
    }).catch((error) => {
      const errorMessage = error.response.data?.errorMessages[0] ?? 'Não foi possível exportar a lista de posições.';

      toastr.error('Ops...', errorMessage);
    }).finally(() => setIsLoading(false));
  }, []);

  const renderOutdatedPositions = () => (
    <>
      <Text larger>Posições Desatualizadas!</Text>
      <br />
      <Text>Para cotações de saída antecipada, favor entrar em contato com a Mesa de Produtos Estruturados.</Text>
      <br />
      <Text>Canal de atendimento para cotações no HUB:</Text>
      <Link>
        <a size="md" icon="message-square" color="#E0AD00" />
        <a href="https://hub.xpi.com.br/dashboard/#/performance" target="_blank" rel="noopener noreferrer">Abrir Chat</a>
      </Link>
    </>
  );


  return (
    <BlackContainer>
      <Page>
        {(isLoading || filterIsLoading) && <Loading text="Carregando..." fixed />}

        <UnwindingFilter
          onFilter={filterData => setFilteredOptions(oldState => ({ ...oldState, ...filterData }))}
          onFilterSlider={filterData => setFilteredOptions(oldState => ({ ...oldState, ...filterData }))}
          onClear={filterData => setFilteredOptions(oldState => ({ ...oldState, ...filterData }))}
          filterNames={[
            { name: 'advisorCodes', size: 25 },
            { name: 'clients', size: 200 },
            { name: 'tickers', size: 200 },
            { name: 'structures', size: 95 },
          ]}
          options={{
            AdvisorCodes: filters?.advisorCodes || [],
            Clients: filters?.clients || [],
            Tickers: filters?.tickers || [],
            Structures: filters?.structures || [],
            OperationTimeByMonth: filters?.operationTimeByMonth || { min: 0, max: 0 },
            CurrentProfitPercentage: filters?.currentProfitPercentage || { min: 0, max: 0 },
            CurrentProfitOnMaxContractedPercentage: filters?.currentProfitOnMaxContractedPercentage || { min: 0, max: 0 },
            OperationIds: filters?.operationIds,
          }}
        />

        <WrapperTable>
          <Row justifyContent="space-between" align="baseline" border>
            <H1 noMargin>Antecipação</H1>
            {positions?.length > 0 && !outdatedPositions
                && (
                <Dropdown
                  title="Exportar Posições Disponíveis"
                  items={[
                    { text: 'Excel',
                      link: () => {
                        onGetReport(filteredOptions);
                      } },
                  ]}
                />
                )
              }
          </Row>

          {outdatedPositions && renderOutdatedPositions()}
          {(!outdatedPositions) && (
          <GenericTableBox
            onUpdate={() => refetchAntecipation()}
            title="Lista de Posições"
            orderBy={{
              onChange: setOrderBy,
              title: 'Ordernar pela coluna:',
              initialOptions: { label: 'Resultado Bruto Atual (%)', value: 'CurrentPosition.Profit.Percentage' },
              options: [
                { label: 'Cliente', value: 'ClientId' },
                { label: 'Estrutura', value: 'Structure.Name' },
                { label: 'Quantidade', value: 'Quantity' },
                { label: 'Entrada', value: 'AcquisitionDate' },
                { label: 'Encerramento', value: 'MaturityDate' },
                { label: 'Tempo na Operação', value: 'ElapsedOperationTime.InDays' },
                { label: 'Resultado Bruto Atual (%)', value: 'CurrentPosition.Profit.Percentage' },
                { label: 'Ganho Atual/Ganho Máximo (%)', value: 'CurrentPosition.Profit.OnMaxContractedPercentage' },
                { label: 'Perform. Ativo (R$)', value: 'CurrentPosition.AssetPerformanceValue' },
                { label: 'Perform. Estrutura (R$)', value: 'CurrentPosition.Profit.WithoutAsset' },
              ],
            }}
            pagination={{
              onPageChange,
              currentPage: pagination.currentPage,
              totalPages: newTotalPages,
            }}
          >
            <UnwindingTable
              onOpenUnwinding={position => onOpenTableDialog(position, false)}
              onOpenDetails={position => onOpenTableDialog(position, true)}
              data={positions}
            />

            <UnwindingDialog
              onAcceptTerm={onAcceptTerm}
              isLoading={antecipateIsLoading}
              onClose={onCloseTableDialog}
              position={positionSelected}
              isOpen={isOpenTableUnwindingDialog}
            />

            <UnwindingDetailsDialog
              onClose={onCloseTableDialog}
              position={positionSelected}
              isOpen={isOpenTableDetailsDialog}
            />
          </GenericTableBox>
          )}
        </WrapperTable>
      </Page>
    </BlackContainer>
  );
};

export default UnwindingPage;
